import { motion } from "framer-motion";

import { Announcement } from "~/components/site/announcement";
import { Footer } from "~/components/site/footer";
import { Header } from "~/components/site/header";
import { container } from "~/components/site/layout";

type Props = Readonly<{
  children: React.ReactNode;
}>;

export function Layout({ children }: Props): JSX.Element {
  return (
    <>
      <Announcement />
      <Header />
      <motion.main
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        id="main"
        className="dark:bg-black dark:text-white grow pt-16"
      >
        <div className="container">{children}</div>
      </motion.main>
      <Footer />
    </>
  );
}
